import {Navigate, Outlet} from 'react-router-dom';
import {isLoggedIn} from '../../utils';

const ProtectedRoute = ({redirectPath = '/login', children}) => {
    if (!isLoggedIn()) {
        return <Navigate to={redirectPath} replace/>;
    }
    return children ? children : <Outlet/>;
};

export default ProtectedRoute;